import React from "react";
import { useNavigate } from "react-router-dom";
import "./OurProducts.css";

const products = [
  {
    name: "Bottoming Tap",
    image: "/products/Bottoming-Taps.jpg1.webp",
  },
  {
    name: "Extension Tap",
    image: "/products/Extension-Taps.jpg.webp",
  },
  {
    name: "Forming Tap",
    image: "/products/Forming-Taps.jpeg.webp",
  },
  {
    name: "Interrupted Thread Tap",
    image: "/products/Interrupted-Thread-Taps.jpeg.webp",
  },
  {
    name: "Gear Hob Cutter",
    image: "/products/Gear-hob.jpg",
  },
  {
    name: "Involute Spline Hob",
    image: "/products/Involute-spline-hob.jpg",
  },
  {
    name: "Pipe Tap",
    image: "/products/Pipe-Taps.jpg.webp",
  },
  {
    name: "Plug Tap",
    image: "/products/Plug-Taps.jpg.webp",
  },
  {
    name: "Punch Tap",
    image: "/products/Punch-Taps.jpg.webp",
  },
  {
    name: "Spiral Flute Taps",
    image: "/products/Spiral-Flute-Taps-1536x218.jpg.webp",
  },
  {
    name: "Taper Taps",
    image: "/products/Taper-Taps.webp",
  },
];

const ProductsPreview = () => {
  const navigate = useNavigate();

  return (
    <div className="products-preview-section">
      <h2 className="section-title">Explore Our Products</h2>
      <div className="products-preview-grid">
        {products.slice(0, 6).map((product, index) => (
          <div
            className="preview-card"
            key={index}
            onClick={() => navigate("/products")}
          >
            <img
              src={product.image}
              alt={product.name}
              className="preview-image"
            />
            <h3 className="preview-title">{product.name}</h3>
          </div>
        ))}
      </div>

      <button className="view-all-btn" onClick={() => navigate("/products")}>
        View All Products
      </button>
    </div>
  );
};

export default ProductsPreview;
